import { Modal } from '@mui/material';
import { CloseOutlined } from '@mui/icons-material';
import React, { useState } from "react";
import styled from "styled-components";
import { DownOutlined } from "@ant-design/icons";

const PreviewRubric = ({ open, close, rubrics_meta = [] , mainTitle=""}) => {

  const maxPoint = rubrics_meta?.reduce(
    (sum, criterion) =>
      sum + Math.max(...criterion.points.map((point) => point.pointText)),
    0
  );

  const [rubricOpen, setRubricOpen] = useState(
    rubrics_meta.reduce((acc, _, index) => {
      acc[index] = false;
      return acc;
    }, {})
  );

  const resetRubricOpen = () => {
    const resetState = rubrics_meta.reduce((acc, _, index) => {
      acc[index] = false;
      return acc;
    }, {});
    setRubricOpen(resetState);
  };

  const toggleRubricOpen = (index) => {
    setRubricOpen((prevOpen) => ({
      ...prevOpen,
      [index]: !prevOpen[index],
    }));
  };
  const closeModel=()=>{
    resetRubricOpen();
    close();
  }

  return (
    <Modal open={open} onClose={closeModel}>
      <ModalContent orientation={window.screen.orientation}>
        <HeaderContainer className="flex items-center">
          <CloseOutlined onClick={closeModel} className="cursor-pointer" />
        </HeaderContainer>
        <div className="rubric-container" style={{width: "calc(100% - 55px)"}}>
          <div className="rubricHeader">
            <h2>{mainTitle}</h2>
            <div>
              <span className="score">/{maxPoint}</span>
            </div>
          </div>

          {rubrics_meta.map((criterion, index) => (
            <div key={index} className="rubric-section">
              <div className="allClrSection">
                <h4>{criterion.criterionTitle}</h4>
                <div className="assignmentPoints">
                  <p>{`/${Math.max(...criterion.points.map((point) => point.pointText))}`}</p>
                  <div
                    className="rubricContainer"
                    onClick={() => toggleRubricOpen(index)}
                  >
                    <div
                      style={{
                        transition: "transform 0.4s ease-in-out",
                        transform: rubricOpen[index]
                          ? "rotate(-180deg)"
                          : "rotate(0deg)",
                      }}
                    >
                      <DownOutlined style={{ color: "rgb(14 70 183 / 87%)" }} />
                    </div>
                  </div>
                </div>
              </div>

              {!rubricOpen[index] ? (
                <div>
                  <p>{criterion.criterionDescription}</p>
                  <div className="rubric-items">
                    {criterion.points.map((point, pointIndex) => (
                      <div key={pointIndex} className={`rubric-item cursor-default `}>
                        <div className="allRubricPoint">
                          <div className="rubricPoint">
                            {point.title}
                            <span>{point.pointText} pts</span>
                          </div>
                          <p style={{ fontSize: "13px" }}>
                            {point.description}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <div className="rubric-items" style={{ width: "100%", overflowX: "auto" }}>
                  {criterion.points.map((point, pointIndex) => (
                    <div key={pointIndex} className="rubricNewSection" style={{ width: "fit-content", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <label style={{ whiteSpace: "nowrap" }}>{point.pointText} pts</label>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </ModalContent>
    </Modal>
  );
};

const HeaderContainer = styled.div`
  align-items: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  display: flex;
  flex-shrink: 0;
  justify-content: space-between;
  line-height: 1.5rem;
  padding-inline: 20px;
  padding-top: 15px;
  padding-bottom: 15px;
`;
const ModalContent = styled.div`
  background-color: white;
  position: relative;
  width: ${(props) => (props.orientation === "landscape" ? "90%" : "100%")};
  height: ${(props) => (props.orientation === "landscape" ? "80%" : "100%")};
  display: flex;
  flex-direction: column;
  overflow: scroll;
`;

export default PreviewRubric;
